import axios from "axios";
import router from "../router";
import Vue from "vue";
import { Loading } from "element-ui";
import _ from "lodash";
import { saveAs } from "file-saver";

import domainNameConfig from "@/domainNameConfig";
window.localStorage.setItem(
  "domainNameConfig",
  JSON.stringify(domainNameConfig)
);
const service = axios.create({
  baseURL: domainNameConfig,
  timeout: 1000 * 120,
});

//loading对象
let loading;
let flag;
//当前正在请求的数量
let needLoadingRequestCount = 0;

//显示loading
function showLoading(target) {
  // 后面这个判断很重要，因为关闭时加了抖动，此时loading对象可能还存在，
  // 但needLoadingRequestCount已经变成0.避免这种情况下会重新创建个loading
  if (needLoadingRequestCount === 0 && !loading) {
    loading = Loading.service({
      lock: true,
      text: "数据加载中...",
      background: "rgba(255, 255, 255, 0.4)",
      target: document.getElementById("indexMain"),
    });
  }
  needLoadingRequestCount++;
}

//隐藏loading
function hideLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    loading.close();
    loading = null;
  }
}
service.interceptors.request.use(
  (config) => {
    console.log("config", config);
    //判断当前请求是否设置了不显示Loading
    if (!flag) {
      showLoading();
    }
    // 新增不需要传token，传使用传的tolen，不传取缓存的
    config.headers.authorization =
      config.headers.authorization || localStorage.getItem("Authorization");
    let requestObj = JSON.parse(JSON.stringify(config));
    delete requestObj.headers.loading;
    return config;
  },
  (error) => {
    if (!flag) {
      setTimeout(() => {
        hideLoading();
      }, 200);
    }
    return Promise.reject();
  }
);
service.interceptors.response.use(
  (response) => {
    console.log("response+++111", response);
    //判断当前请求是否设置了不显示Loading（不显示自然无需隐藏）
    if (!flag) {
      setTimeout(() => {
        hideLoading();
      }, 200);
    }
    // 未设置状态码则默认成功状态
    const code = (response.data.error ? response.data.error.code : "") || 200;
    if (
      code == 20002 ||
      code == 20001 ||
      code == 20003 ||
      code == 20004 ||
      code == 20007 ||
      code === 20005 ||
      code === 20008
    ) {
      Vue.prototype.$message.closeAll();
      Vue.prototype.$message({
        message: response.data.error.message,
        type: "error",
        offset: 30,
        duration: 4000,
      });
      Promise.reject();
    }
    //统一判断目前登录用户是否已经过期
    if (
      code === 408 ||
      code === 407 ||
      code === 406 ||
      code === 409 ||
      code === 410 ||
      code === 411
    ) {
      // if(localStorage.getItem('Authorization')) {

      // }
      Vue.prototype.$message({
        message:
          code === 409 || code === 410 || code == 411
            ? response.data.error.message
            : "登录状态已过期，请重新登录！",
        type: code === 409 || code === 411 ? "error" : "info",
        offset: 30,
        duration: 4000,
        customClass: code === 409 || code === 411 ? "" : "info-message",
      });
      localStorage.removeItem("Authorization");
      localStorage.removeItem("url");
      localStorage.removeItem("routerList");
      localStorage.removeItem("myDepartment");
      localStorage.removeItem("userId");
      router.push("/login");
      Promise.reject();
    } else if (response.status === 200) {
      return response.data;
    } else if (response.status === 302) {
      console.log("response++++", response);
    } else {
      Promise.reject();
    }
  },
  (error) => {
    setTimeout(() => {
      hideLoading();
    }, 200);
    return Promise.reject();
  }
);
function request(options, myLoading) {
  flag = myLoading;
  if (flag) {
    needLoadingRequestCount = 0;
    if (loading && loading != null) {
      loading.close();
      loading = null;
    }
  }
  return service(options);
}
let downloadLoadingInstance;
// 通用下载方法 headerType:true->application/x-www-form-urlencoded
export function download(
  url,
  filename,
  params,
  authorization,
  headerType,
  methods
) {
  flag = true;
  downloadLoadingInstance = Loading.service({
    text: "正在下载数据，请稍后",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  if (methods) {
    return service
      .get(url, {
        headers: {
          "Content-Type": headerType
            ? "application/x-www-form-urlencoded"
            : "application/json",
          authorization: authorization,
        },
        responseType: "blob",
        timeout: 1000 * 120,
      })
      .then((data) => {
        const content = data;
        const blob = new Blob([content]);
        saveAs(blob, filename);
        downloadLoadingInstance.close();
      })
      .catch((r) => {
        Vue.prototype.$message({
          message: "下载文件出现错误，请联系管理员！",
          type: "error",
          offset: 30,
          duration: 4000,
        });
        downloadLoadingInstance.close();
      });
  } else {
    return service
      .post(url, params, {
        headers: {
          "Content-Type": headerType
            ? "application/x-www-form-urlencoded"
            : "application/json",
          authorization: authorization,
        },
        responseType: "blob",
        timeout: 1000 * 120,
      })
      .then((data) => {
        const content = data;
        const blob = new Blob([content]);
        saveAs(blob, filename);
        downloadLoadingInstance.close();
      })
      .catch((r) => {
        Vue.prototype.$message({
          message: "下载文件出现错误，请联系管理员！",
          type: "error",
          offset: 30,
          duration: 4000,
        });
        downloadLoadingInstance.close();
      });
  }
}
/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams(params) {
  let result = "";
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && typeof value !== "undefined") {
      if (typeof value === "object") {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && typeof value[key] !== "undefined") {
            let params = propName + "[" + key + "]";
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result;
}
export default request;
